import React, { useState } from "react";
import ToastSnackbar from "./ToastSnackbar";
import { useNavigate } from "react-router-dom";

const ToastSnackbarWrapper = ({ selectedPapers = [], setSelectedPapers, handleSaveCollection, setActiveTab, showToastSnackbar, setShowToastSnackbar }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleClearAll = () => {
    setSelectedPapers([]);
  };

  const handleBookmark = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handlePreviewAndSave = () => {
    setLoading(true);
    setTimeout(() => {
      navigate("/exam-papers/mathematics/document-preview");
    }, 2000);
  };

  return (
    <ToastSnackbar
      show={selectedPapers.length > 0 || showToastSnackbar}
      onClose={handleClearAll}
      papersSelected={selectedPapers.length}
      onClearAll={handleClearAll}
      onBookmark={handleBookmark}
      onPreviewAndSave={handlePreviewAndSave}
      loading={loading}
      showModal={showModal}
      onModalClose={handleModalClose}
      setActiveTab={setActiveTab}
      handleSaveCollection={handleSaveCollection}
      setShowToastSnackbar={setShowToastSnackbar}
    />
  );
};

export default ToastSnackbarWrapper;
